export const blockIconsEditorAutoGraph = (
	<span className='material-symbols-outlined'>auto_graph</span>
);
